import React, { useContext, useEffect, useMemo, useState } from 'react';
import TileButton from 'components/atoms/TileButton';
import PlanComparisonContainer from './PlanComparisonContainer';
import BulkExportContainer from 'components/molecules/TradePromoOptimization/BulkExport/BulkExportContainer';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { TPO_REPORTS_SUB_TAB_CHANGED } from 'utils/mixpanelEventNames';

export enum ReportTabKeys {
    PlanComparison = 'plan_comparison',
    BulkExports = 'bulk_exports',
}

type ReportTab = {
    key: string;
    label: string;
};

const subHeader = '';

const Reports = () => {
    const { appConfig } = useContext(UserContext);
    const { reportTabs } = getConfig('tradePromoOptimization', appConfig);

    const subTileData = [
        {
            label: 'Plan Comparison',
            key: ReportTabKeys.PlanComparison,
            component: <PlanComparisonContainer />,
        },
        {
            label: 'Bulk Exports',
            key: ReportTabKeys.BulkExports,
            component: <BulkExportContainer />,
        },
    ];

    const filteredTabs = useMemo(() => {
        if (!reportTabs) return [];
        return subTileData.filter((tab) => reportTabs.some((t: ReportTab) => t.key === tab.key));
    }, [reportTabs, subTileData]);

    const [selectedTile, setSelectedTile] = useState(filteredTabs[0]);

    useEffect(() => {
        if (selectedTile?.key) {
            trackEventMixpanel(TPO_REPORTS_SUB_TAB_CHANGED, {
                tabName: selectedTile?.label,
            });
        }
    }, [selectedTile?.key]);

    if (!filteredTabs.length) return null;

    return (
        <div className="relative">
            <h5 className={`font-xs m-0 font-normal text-fontGreyAlt mt-2`}>{subHeader} </h5>
            <div className="my-2 border-b border-borderGreyAlt"></div>
            <div className="absolute left-0 top-3">
                <TileButton
                    style={{ width: 'min-content' }}
                    data={filteredTabs}
                    activeKey={selectedTile?.key}
                    onClick={(item: any) => {
                        if (item?.key === selectedTile?.key) return;
                        setSelectedTile(item);
                    }}
                />
            </div>
            {selectedTile?.component}
        </div>
    );
};

export default Reports;
